import { useEffect, useRef } from "react";
import { Reveal } from "./Reveal";
import { MAILERLITE_EMBED_HTML } from "./mailerliteEmbed";

export default function Signup() {
    const markerRef = useRef(null);

    useEffect(() => {
        if (markerRef.current && markerRef.current.childNodes.length === 0) {
            markerRef.current.appendChild(
                document.createComment(" TUTAJ WKLEJ KOD FORMULARZA MAILERLITE ")
            );
        }
        window.ml_webform_success_6131832 = function () {
            try {
                window.top.location.href = window.location.origin + "/dziekujemy";
            } catch (o) {
                window.location.href = "/dziekujemy";
            }
        };
        if (!document.querySelector('script[data-mailerlite-webforms]')) {
            const s = document.createElement("script");
            s.src = "https://static.mailerlite.com/js/w/webforms.min.js?vd4de52e171e8eb9c47c0c20caf367ddf";
            s.type = "text/javascript";
            s.async = true;
            s.setAttribute("data-mailerlite-webforms", "true");
            document.body.appendChild(s);
        }
    }, []);

    return (
        <section id="zapis" className="py-14 sm:py-20 px-4 sm:px-8 scroll-mt-20" data-testid="signup-section">
            <div className="max-w-4xl mx-auto rounded-[2.5rem] bg-gradient-to-br from-brand-darker via-brand-deep to-brand px-5 sm:px-12 py-14 sm:py-20 relative overflow-hidden shadow-[0_50px_100px_-40px_rgba(143,15,69,0.7)]">
                <div
                    aria-hidden="true"
                    className="absolute inset-0 opacity-[0.12] hero-grid-bg"
                />
                <div
                    aria-hidden="true"
                    className="absolute -top-28 -right-28 w-96 h-96 rounded-full border-[2.5rem] border-white/10"
                />
                <div
                    aria-hidden="true"
                    className="absolute -bottom-32 -left-24 w-80 h-80 rounded-full bg-white/10 blur-3xl"
                />

                <div className="relative">
                    <div className="text-center">
                        <Reveal>
                            <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.1]">
                                Zapisz się bezpłatnie na webinar
                            </h2>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <p className="mt-5 text-base sm:text-lg text-white/85 leading-relaxed max-w-xl mx-auto">
                                Wypełnij krótki formularz, a wszystkie informacje dotyczące udziału
                                otrzymasz na podany adres e-mail.
                            </p>
                        </Reveal>
                    </div>

                    <Reveal delay={0.22} className="mt-10">
                        {/* Kontener na formularz MailerLite — podmień zawartość na kod embed */}
                        <div ref={markerRef} className="contents" />
                        <div
                            className="rounded-3xl bg-white p-6 sm:p-10 shadow-2xl"
                            data-testid="mailerlite-embed-container"
                        >
                            <div dangerouslySetInnerHTML={{ __html: MAILERLITE_EMBED_HTML }} />
                        </div>
                    </Reveal>

                    <Reveal delay={0.3}>
                        <p className="mt-6 text-center text-sm text-white/70" data-testid="signup-reassurance">
                            Bezpłatnie · bez zobowiązań · link do spotkania wyślemy e-mailem
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
